import { GET_DAILY_TASK_REWARDS, UPDATE_DAILY_TASK_REWARDS } from "./types";

const initialState = { tasks: [] };

const dailyTaskRewardReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_DAILY_TASK_REWARDS:
      return { ...state, tasks: action.payload };
    case UPDATE_DAILY_TASK_REWARDS:
      return {
        ...state,
        tasks: state.tasks.map((task) =>
          task._id === action.payload._id ? action.payload : task,
        ),
      };
    default:
      return state;
  }
};

export default dailyTaskRewardReducer;
